var map = {
	"./affix/style/index.js": "./components/affix/style/index.js",
	"./alert/style/index.js": "./components/alert/style/index.js",
	"./anchor/style/index.js": "./components/anchor/style/index.js",
	"./auto-complete/style/index.js": "./components/auto-complete/style/index.js",
	"./avatar/style/index.js": "./components/avatar/style/index.js",
	"./back-top/style/index.js": "./components/back-top/style/index.js",
	"./badge/style/index.js": "./components/badge/style/index.js",
	"./breadcrumb/style/index.js": "./components/breadcrumb/style/index.js",
	"./button/style/index.js": "./components/button/style/index.js",
	"./calendar/style/index.js": "./components/calendar/style/index.js",
	"./card/style/index.js": "./components/card/style/index.js",
	"./carousel/style/index.js": "./components/carousel/style/index.js",
	"./cascader/style/index.js": "./components/cascader/style/index.js",
	"./checkbox/style/index.js": "./components/checkbox/style/index.js",
	"./col/style/index.js": "./components/col/style/index.js",
	"./collapse/style/index.js": "./components/collapse/style/index.js",
	"./comment/style/index.js": "./components/comment/style/index.js",
	"./config-provider/style/index.js": "./components/config-provider/style/index.js",
	"./date-picker/style/index.js": "./components/date-picker/style/index.js",
	"./divider/style/index.js": "./components/divider/style/index.js",
	"./drawer/style/index.js": "./components/drawer/style/index.js",
	"./dropdown/style/index.js": "./components/dropdown/style/index.js",
	"./form/style/index.js": "./components/form/style/index.js",
	"./grid/style/index.js": "./components/grid/style/index.js",
	"./icon/style/index.js": "./components/icon/style/index.js",
	"./input-number/style/index.js": "./components/input-number/style/index.js",
	"./input/style/index.js": "./components/input/style/index.js",
	"./layout/style/index.js": "./components/layout/style/index.js",
	"./list/style/index.js": "./components/list/style/index.js",
	"./locale-provider/style/index.js": "./components/locale-provider/style/index.js",
	"./menu/style/index.js": "./components/menu/style/index.js",
	"./message/style/index.js": "./components/message/style/index.js",
	"./modal/style/index.js": "./components/modal/style/index.js",
	"./notification/style/index.js": "./components/notification/style/index.js",
	"./pagination/style/index.js": "./components/pagination/style/index.js",
	"./popconfirm/style/index.js": "./components/popconfirm/style/index.js",
	"./popover/style/index.js": "./components/popover/style/index.js",
	"./progress/style/index.js": "./components/progress/style/index.js",
	"./radio/style/index.js": "./components/radio/style/index.js",
	"./rate/style/index.js": "./components/rate/style/index.js",
	"./row/style/index.js": "./components/row/style/index.js",
	"./select/style/index.js": "./components/select/style/index.js",
	"./skeleton/style/index.js": "./components/skeleton/style/index.js",
	"./slider/style/index.js": "./components/slider/style/index.js",
	"./spin/style/index.js": "./components/spin/style/index.js",
	"./steps/style/index.js": "./components/steps/style/index.js",
	"./switch/style/index.js": "./components/switch/style/index.js",
	"./table/style/index.js": "./components/table/style/index.js",
	"./tabs/style/index.js": "./components/tabs/style/index.js",
	"./tag/style/index.js": "./components/tag/style/index.js",
	"./time-picker/style/index.js": "./components/time-picker/style/index.js",
	"./timeline/style/index.js": "./components/timeline/style/index.js",
	"./tooltip/style/index.js": "./components/tooltip/style/index.js",
	"./transfer/style/index.js": "./components/transfer/style/index.js",
	"./tree-select/style/index.js": "./components/tree-select/style/index.js",
	"./tree/style/index.js": "./components/tree/style/index.js",
	"./upload/style/index.js": "./components/upload/style/index.js",
	"./version/style/index.js": "./components/version/style/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.js?$";